
import './../../components/atoms/background-image/background-image.js'
import './../../components/atoms/picture/picture.js'
import './../../components/molecules/questions/questions.js'
import './../../components/organisms/interactive-body/interactive-body.js'
import './../../components/organisms/interactive-puzzle/interactive-puzzle.js'
import './../../components/organisms/module-marquee/module-marquee.js'
import './../../components/structures/footer/footer.js'
import './../../components/structures/menu-bar/menu-bar.js'
import './../../components/structures/quiz/quiz.js'
import './../../components/structures/skip-to-main/skip-to-main.js'

import displayHelloConsoleMessage from './../../vendor/scripts/fabrique/modules/console-hello'
import fireCustomEvent from './../../vendor/scripts/fabrique/modules/fire-custom-event'
import konamiCode from './../../vendor/scripts/fabrique/modules/konami-code'
import preventTransitionsOnResize from './../../vendor/scripts/fabrique/modules/prevent-transitions-on-resize'

// Intersection observer polyfill - about 20kb raw, but we need it for IE11 & Safari
if (!window.IntersectionObserver) {
  require('intersection-observer')
  window.IntersectionObserver.prototype.POLL_INTERVAL = 250 // Time in milliseconds.
}

// Import smooth scroll - for IE 11, Chrome < 61, Firefox < 36, Safari
if (!('scrollBehavior' in document.documentElement.style)) {
  require('smoothscroll-polyfill').polyfill()
}

// Web animations polyfill - about 50kb raw, so only use if you need it
// require('web-animations-js');

displayHelloConsoleMessage('Made with ♥ by TwoKings+Fabrique')
preventTransitionsOnResize()
konamiCode(() => document.documentElement.classList.add('konami-code'))

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
fireCustomEvent('init-immediate')
window.addEventListener('DOMContentLoaded', () => fireCustomEvent('init-load'))
window.addEventListener('load', () => fireCustomEvent('init-after-load'))
window.addEventListener('load', () => window.setTimeout(() => fireCustomEvent('init-delayed-load', 500)))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))
